// extracted by mini-css-extract-plugin
module.exports = {"content":"dp-OdNq1Tt2","mainContent":"dp-QwGa9Or4","title":"dp-Oqr42C40","inputContainer":"dp-tT7ifCso","searchBtn":"dp-MyMTmXjQ"};